// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__QiWYH","footerContainer":"Footer_footerContainer__TC+0s","socialIcons":"Footer_socialIcons__ilDUf","footerLegal":"Footer_footerLegal__uZTae"};